import React from 'react';
import idcardcss from '../pages/css/idcard.module.css';
import { useState } from 'react';
import { useEffect } from 'react';
import { createdoctype, changedoctype } from '../tools/filehandler';
import { setErrorMessage } from "../tools/errorhandling";
import { CgCloseR } from "react-icons/cg";
import Button from 'react-bootstrap/Button';
import moment from 'moment';



const HistorydetailsEmployee = ({ rights, t, employee, events }) => {
    useEffect(() => {
        
        if(employee !== undefined)
        {
            //console.log("emp =", employee)
            //document.getElementById("doctype_description").value ={employee.achternaam} & ", " & {employee.voornaam};
        }
    }, [employee]);

   
    const handleCancel = () => {
        document.getElementById("coverAll").style.display = 'none'
    }
    // 
    return (
        <div id="HistorydetailsEmployee" className='focusOfTheDay'>
            {/* onMouseDown={(e) => events.startdrag("add_documenttype", true, e)} onMouseUp={(e) => events.startdrag(null, false, e)} */}
            <div className='formcaption' >{t('UserInOutService')} <CgCloseR className='closer' onClick={handleCancel} /></div>
            <div className="AssignCleaningform">
                  <label className='labelhotel' style={{ padding: '12px' }}>
                    {t('Active')}:
                </label>
                <input id="Active" name="title" className="doublegrid" type='text' value={employee.actief === 0? t('No'):t('Yes')}  disabled>
                </input>
                <label className='labelhotel' style={{ padding: '12px' }}>
                    {t('Naam')}:
                </label>
                <input id="doctype_description" name="title" className="doublegrid" type='text' value={employee.achternaam +", " +employee.voornaam} disabled>
                </input>
                 <label className='labelhotel' style={{ padding: '12px' }}>
                    {t('Indienst')}:
                </label>
                <input id="in_dienstdatum" name="title" className="doublegrid" type='text' value={moment(new Date(employee.in_dienstdatum)).format("DD-MMM-YYYY")} disabled>
                </input>
                 <label className='labelhotel' style={{ padding: '12px' }}>
                    {t('Uitdienst')}:
                </label>
                <input id="uit_dienstdatum" name="title" className="doublegrid" type='text' value={moment(new Date(employee.uit_dienstdatum)).format("DD-MMM-YYYY")} disabled>
                </input>
                &nbsp;
            </div>

        </div>
    );
};


export default HistorydetailsEmployee;
